module.exports = __webpack_public_path__ + "assets/BngMUXZYTXPIvIBgJJSb6ufJ5qW54A-c0a77b.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/BngMUXZYTXPIvIBgJJSb6ufJ5qW54A.woff2
// module id = 868
// module chunks = 2